import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { normalizeDecimalInput } from '../utils/format';
import '../App.css';

const SettingsModal = ({ isOpen, onClose, slippageBps, slippageMode, onSlippageChange }) => {
  const [customValue, setCustomValue] = useState('');

  const presets = [
    { label: 'Auto', mode: 'auto', bps: null },
    { label: '0.1%', mode: 'manual', bps: 10 },
    { label: '0.5%', mode: 'manual', bps: 50 },
    { label: '1.0%', mode: 'manual', bps: 100 }
  ];

  const handlePresetClick = (preset) => {
    onSlippageChange(preset.bps || 50, preset.mode);
    setCustomValue('');
  };

  const handleCustomChange = (e) => {
    const val = normalizeDecimalInput(e.target.value);
    setCustomValue(val);
    if (val) {
      const bps = Math.round(parseFloat(val) * 100);
      onSlippageChange(bps, 'manual');
    }
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="lr-modal"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.25, ease: "easeInOut" }}
          onClick={onClose}
        >
          <motion.div 
            className="lr-modal-backdrop"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
          />
          <motion.div
            className="lr-modal-content"
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            transition={{ 
              duration: 0.25, 
              ease: [0.4, 0, 0.2, 1]
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="lr-modal-header">
              <h3>Swap Settings</h3>
              <button className="lr-modal-close" onClick={onClose} data-press>
                ✕
              </button>
            </div>

            <div className="lr-modal-body">
              <div className="lr-slippage-row">
                <span className="lr-slippage-label">Slippage tolerance</span>
              </div>

              <div className="lr-slipbar">
                {presets.map((preset) => {
                  const isActive =
                    preset.mode === slippageMode &&
                    (preset.mode === 'auto' || preset.bps === slippageBps);
                  return (
                    <button
                      key={preset.label}
                      className={`lr-slipseg ${isActive ? 'lr-slipseg-active' : ''}`}
                      onClick={() => handlePresetClick(preset)}
                      data-press
                    >
                      {preset.label}
                    </button>
                  );
                })}

                <div className="lr-slipcustom">
                  <input
                    className="lr-slipcustom-input"
                    type="text"
                    inputMode="decimal"
                    placeholder="Auto"
                    value={customValue}
                    onChange={handleCustomChange}
                  />
                  <span className="lr-slipcustom-suffix">%</span>
                </div>
              </div>

              <p className="lr-helper-text" style={{ marginTop: '10px' }}>
                Higher slippage can help your swap execute in volatile market, but also increases
                risk of front-running.
              </p>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default SettingsModal;
